import { useMediaQuery } from "@mui/material";

export const useIsDesktopMediaQuery = () => {
    const isDesktop = useMediaQuery('(min-width: 720px)');
    return isDesktop;
}
